import { alpha } from "@material-ui/core/styles";
import { makeStyles } from "@saleor/macaw-ui";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    active: {
      color: theme.palette.text.secondary,
    },
    root: {
      "&$active": {
        borderBottomColor: theme.palette.primary.main,
        borderBottomWidth: 3,
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
      },
      "&:focus": {
        color: theme.palette.primary.main,
        outline: "none",
      },
      "&:hover": {
        color: theme.palette.primary.main,
        backgroundColor: alpha(theme.palette.primary.main, 0.04),
      },
      borderBottom: "3px solid transparent",
      borderRadius: `${theme.spacing(0.5)} ${theme.spacing(0.5)} 0 0`,
      color: alpha(theme.palette.text.secondary, 0.7),
      cursor: "pointer",
      display: "inline-block",
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: "14px",
      lineHeight: "20px",
      marginRight: theme.spacing(1),
      minWidth: 80,
      padding: `${theme.spacing(1.5)} ${theme.spacing(2.5)}`,
      transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
      userSelect: "none",
    },
  }),
  { name: "Tab" },
);

interface TabProps<T> {
  children?: React.ReactNode;
  isActive: boolean;
  changeTab: (index: T) => void;
  testId?: string;
}

export function Tab<T>(value: T) {
  const Component = (props: TabProps<T>) => {
    const { children, isActive, changeTab, testId } = props;
    const classes = useStyles(props);

    return (
      <span
        data-test-id={testId}
        className={clsx({
          [classes.root]: true,
          [classes.active]: isActive,
        })}
        onClick={() => changeTab(value)}
      >
        {children}
      </span>
    );
  };

  return Component;
}

export default Tab;
